import axiosInstance from '../lib/api/axiosInstance';
import { Network } from '../types';

// Aligned with backend create/update payload: name, bqKey (required), optional status/country/currency
export interface NetworkFormData {
  name: string;
  bqKey: string;
  status?: string;      // NetworkStatus enum string
  country?: string | null;
  currency?: string | null;
}

export const networksApi = {
  // Get all networks
  getAll: async (): Promise<Network[]> => {
    const response = await axiosInstance.get<Network[]>('/networks');
    return response.data;
  },

  // Get network by ID
  getById: async (id: number): Promise<Network> => {
    const response = await axiosInstance.get<Network>(`/networks/${id}`);
    return response.data;
  },

  // Create new network
  create: async (data: NetworkFormData): Promise<Network> => {
    const payload = {
      name: data.name.trim(),
      bqKey: data.bqKey.trim(),
      ...(data.status && { status: data.status }),
      country: data.country ?? null,
      currency: data.currency ?? null,
    };
    const response = await axiosInstance.post<Network>('/networks', payload);
    return response.data;
  },

  // Update existing network
  update: async (id: number, data: Partial<NetworkFormData>): Promise<Network> => {
    const payload: any = {};
    if (data.name) payload.name = data.name.trim();
    if (data.bqKey) payload.bqKey = data.bqKey.trim();
    if (data.status) payload.status = data.status;
    if (data.country !== undefined) payload.country = data.country ?? null;
    if (data.currency !== undefined) payload.currency = data.currency ?? null;
    const response = await axiosInstance.put<Network>(`/networks/${id}`, payload);
    return response.data;
  },

  // Delete network
  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/networks/${id}`);
  }
};